import dayjs from "dayjs";
import { toast } from "react-toastify";
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" }); // "Jul", "Sep", etc.
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes}`;
};

// export const formatDateWithoutTime = (dateString) => {
//   const date = new Date(dateString);
//   const day = String(date.getDate()).padStart(2, "0");
//   const month = date.toLocaleString("en-US", { month: "short" }); // "Jul", "Sep", etc.
//   const year = date.getFullYear();

//   return `${day}-${month}-${year}`;
// };
export const formatDateWithoutTime = (dateString) => {
  if (!dateString) return "";

  // 1️⃣ Year only
  if (/^\d{4}$/.test(dateString)) {
    return dateString;
  }

  // 2️⃣ MMM/YYYY
  if (/^[A-Za-z]{3}\/\d{4}$/.test(dateString)) {
    const parsed = dayjs(dateString, "MMM/YYYY", true);
    if (parsed.isValid()) {
      return parsed.format("MMM-YYYY");
    }
    return "";
  }

  // 3️⃣ DD/MMM/YYYY (like 19/Nov/2007)
  if (/^\d{1,2}\/[A-Za-z]{3}\/\d{4}$/.test(dateString)) {
    const parsed = dayjs(dateString, "DD/MMM/YYYY", true);
    if (parsed.isValid()) {
      return parsed.format("D-MMM-YYYY");
    }
    return "";
  }

  // 4️⃣ DD-MM-YYYY
  if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(dateString)) {
    const parsed = dayjs(dateString, "DD-MM-YYYY", true);
    if (parsed.isValid()) {
      return parsed.format("D-MMM-YYYY");
    }
    return "";
  }

  // 5️⃣ YYYY-MM-DD
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    const parsed = dayjs(dateString, "YYYY-MM-DD", true);
    if (parsed.isValid()) {
      return parsed.format("D-MMM-YYYY");
    }
    return "";
  }

  return "";
};

export const notifySuccess = (message) => {
  toast.success(message, {
    toastId: "form-creation",
  });
};

export const notifyError = (message) => {
  toast.error(message, {
    toastId: "form-creation",
  });
};

export const notifyWarning = (message) => {
  toast.warn(message, {
    toastId: "form-creation",
  });
};

// export const handleUnsaveNavigation = (e, showDialog, url, navigate) => {
//   if (showDialog) {
//     const confirmLeave = window?.confirm(
//       "You have unsaved changes. Are you sure you want to leave?"
//     );
//     if (!confirmLeave) {
//       e.preventDefault(); // Prevent navigation only if user cancels
//       return;
//     }
//   }
//   navigate(`/${url}`);
// };

// export const handleUnsaveNavigation = createHandleUnsaveNavigation();

export function formatDecimalInput(input, decimalLimit = null) {
  let value = input;

  // Remove all non-numeric and non-decimal characters
  value = value.replace(/[^0-9.]/g, "");

  // Ensure only one decimal point
  const parts = value.split(".");
  if (parts.length > 2) {
    value = parts[0] + "." + parts.slice(1).join("");
  }

  // Limit decimal places if specified
  if (decimalLimit !== null && parts[1]) {
    parts[1] = parts[1].slice(0, decimalLimit);
    value = parts[0] + "." + parts[1];
  }

  // Remove leading zeros unless it's "0." or empty
  if (value && !value.startsWith("0.") && !value.startsWith(".")) {
    value = value.replace(/^0+/, "");
  }

  return value;
}

export const checkCanUpdate = (id, isReadOnly, role) => {
  if (role === "Admin") {
    return true;
  } else {
    if (!id) {
      return true;
    } else if (id && !isReadOnly) {
      return true;
    } else if (id && isReadOnly) {
      return false;
    }
  }
};

export function isEmptyObject(obj) {
  // If there are no keys, it's empty
  if (Object.keys(obj).length === 0) return true;

  // If all values are empty strings (or falsy), return true
  return Object.values(obj).every((value) => value === "");
}

export const normalizeName = (str) => {
  if (typeof str !== "string") {
    console.warn("Invalid field name:", str);
    return "";
  }
  return str.replace(/\s+/g, "_");
};

export const originalsplitFieldsByPageBreak = (fields) => {
  const pages = [];
  let currentPage = [];

  fields.forEach((field) => {
    if (field.type === "PageBreak") {
      pages.push(currentPage); // Save current page
      currentPage = []; // Start a new one
    } else {
      currentPage.push(field);
    }
  });

  if (currentPage.length > 0) {
    pages.push(currentPage);
  }

  return pages;
};

export const splitFieldsByPageBreak = (fields) => {
  const pages = [];
  console.log("Fields133", fields);
  let currentPage = [];

  fields.forEach((field) => {
    if (field.id.startsWith("page")) {
      pages.push(currentPage); // Save current page
      currentPage = []; // Start a new one
    } else {
      currentPage.push(field);
    }
  });

  if (currentPage.length > 0) {
    pages.push(currentPage);
  }

  return pages;
};

export const isHtml = (str) =>
  typeof str === "string" && /<\/?[a-z][\s\S]*>/i.test(str);

export function groupByUniqueId(data) {
  return Object.values(
    data.reduce((acc, item) => {
      if (!acc[item.uniqueId]) {
        acc[item.uniqueId] = {
          id: item.id,
          uniqueId: item.uniqueId,
          lotName: item.lotName,
          quantity: [],
        };
      }
      acc[item.uniqueId].quantity.push({
        name: item.name,
        quantity: item.quantity,
      });
      return acc;
    }, {}),
  );
}

export function formatDateString(isoString) {
  const date = new Date(isoString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" }); // e.g. "Sep"
  const year = date.getFullYear();

  let hours = date.getHours();
  let minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // 0 → 12
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
}

export function convertTimeString(str) {
  const [hours, minutes, seconds] = str.split(":");

  return `${hours}d ${minutes}h ${seconds}m`;
}

export const generateUUID = () => {
  return crypto.randomUUID().toUpperCase();
};

export function isNullObject(obj) {
  if (typeof obj !== "object" || obj === null) {
    throw new Error("Input must be a non-null object");
  }

  // Check if every value in the object is null
  return Object.values(obj).every((value) => value === null);
}

export const noOnlySpaces = (yup, fieldName) =>
  yup
    .string()
    .test(
      "not-only-spaces",
      `${fieldName} cannot contain only spaces`,
      (value) => !value || value.trim().length > 0,
    );

export function isValidDate(date) {
  return date instanceof Date && !isNaN(date);
}

export const validDateRegex =
  /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;

// export const validDateValueRegex = /^\d{4}-\d{2}-\d{2}$/;
export const validDateValueRegex =
  /^(\d{4}-\d{2}-\d{2}|\d{1,2}\/[A-Za-z]{3}\/\d{4}|[A-Za-z]{3}\/\d{4}|\d{4})$/;

export const safelyParse = (value) => {
  if (typeof value !== "string") return value;

  const cleaned = value.trim();

  // If it's wrapped in quotes, unwrap it
  const unwrapped =
    (cleaned.startsWith('"') && cleaned.endsWith('"')) ||
    (cleaned.startsWith("'") && cleaned.endsWith("'"))
      ? cleaned.slice(1, -1)
      : cleaned;

  try {
    return JSON.parse(unwrapped);
  } catch {
    return value;
  }
};

// export const formatDynamicObject = (value) => {
//   // If not object, just return as string
//   if (typeof value !== "object" || value === null) {
//     return String(value);
//   }

//   // If array
//   if (Array.isArray(value)) {
//     return value.map(formatDynamicObject).join(", ");
//   }

//   // Object → Start - xxx , End - xxx
//   return Object.entries(value)
//     .map(([key, val]) => {
//       // Capitalize key
//       const formattedKey =
//         key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();

//       return `${formattedKey} - ${formatDynamicObject(val)}`;
//     })
//     .join(" , ");
// };
export const formatDateWithoutTimeTwo = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", {
    month: "short",
    timeZone: "UTC",
  });
  const year = date.getUTCFullYear();

  return `${day}-${month}-${year}`;
};

const isIsoDateString = (value) =>
  typeof value === "string" && !isNaN(Date.parse(value));

const isDateRangeObject = (value) =>
  value &&
  typeof value === "object" &&
  typeof value.start === "string" &&
  typeof value.end === "string" &&
  isIsoDateString(value.start) &&
  isIsoDateString(value.end);

export const formatDynamicObject = (value) => {
  // 1️⃣ ISO date string → formatted date
  if (isIsoDateString(value)) {
    return formatDateWithoutTimeTwo(value);
  }

  // 2️⃣ Not object
  if (typeof value !== "object" || value === null) {
    return String(value);
  }

  // 3️⃣ Date range object → single clean line
  if (isDateRangeObject(value)) {
    return `Starting Date : ${formatDateWithoutTimeTwo(value.start)}, Ending Date : ${formatDateWithoutTimeTwo(
      value.end,
    )}`;
  }

  // 4️⃣ Array
  if (Array.isArray(value)) {
    return value.map(formatDynamicObject).join(", ");
  }

  // 5️⃣ Generic object (fallback)
  return Object.entries(value)
    .map(([key, val]) => {
      const formattedKey =
        key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();

      return `${formattedKey} - ${formatDynamicObject(val)}`;
    })
    .join(" , ");
};
